export default __webpack_public_path__ + "static/media/Group 27.cedb52cf.png";